"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportSentryError = exports.createSentryScope = void 0;
var tslib_1 = require("tslib");
var sentryClient;
var sentryGlobal = window.Sentry;
if (sentryGlobal && sentryGlobal.BrowserClient) {
    try {
        sentryClient = new sentryGlobal.BrowserClient({
            dsn: 'https://dfc1752d8bd44f2f891ba61ac43e57a9@sentry.wixpress.com/267',
        });
    }
    catch (e) { }
}
exports.createSentryScope = function (tags) {
    if (sentryGlobal && sentryGlobal.Scope) {
        var scope = new sentryGlobal.Scope();
        if (scope.setTags) {
            scope.setTags(tslib_1.__assign(tslib_1.__assign({}, tags), { url: location && location.href }));
        }
        if (scope.setUser) {
            try {
                var clientId = getCookieValue('_wixCIDX');
                var uidx = getCookieValue('_wixUIDX');
                var splitUIDX = uidx.split('|');
                var userId = splitUIDX.pop();
                scope.setUser({
                    id: userId || 'anonymous',
                    clientId: clientId,
                });
            }
            catch (e) { }
        }
        return scope;
    }
};
function reportSentryError(e, tags) {
    if (tags === void 0) { tags = {}; }
    if (sentryClient) {
        try {
            sentryClient.captureException(e, undefined, exports.createSentryScope(tags) || undefined);
        }
        catch (e) { }
    }
}
exports.reportSentryError = reportSentryError;
function getCookieValue(cookieName) {
    var match = document.cookie.match('(^|;)\\s*' + cookieName + '\\s*=\\s*([^;]+)');
    return match ? match.pop() : '';
}
//# sourceMappingURL=SentryReporter.js.map